import { Card, CardContent } from '@/components/ui/card'
import Loader from '@/components/ui/Loader'
import { getCoreRowModel, useReactTable } from '@tanstack/react-table'
import EmptyDatas from 'components/ui/EmptyDatas'
import Table from 'components/ui/my-data-table'
import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import useSWR from 'swr'
import { columns } from './data-table-column'
import DataTableToolbar from './data-table-toolbar'
import { useDlcFramesForm } from './formStore'

const PAGE_SIZE = 60

const DlcPanel = () => {
  const [searchParams] = useSearchParams()
  const setContentTag = useDlcFramesForm((s) => s.setContentTag)
  const contentTag = useDlcFramesForm((s) => s.contentTag)
  const after = useDlcFramesForm((s) => s.after)

  // 支持从 URL 带入标签筛选，例如 /admin?tplTab=dlc-onlines&contentTag=Cat
  useEffect(() => {
    const tag = searchParams.get('contentTag')
    setContentTag(tag || null)
  }, [searchParams, setContentTag])

  const params = {
    limit: PAGE_SIZE,
    ...(contentTag ? { tag: contentTag } : {}),
    ...(after ? { after } : {}),
  }

  const { data, isLoading, isValidating, mutate } = useSWR([
    '/dlc-frames',
    params,
  ])
  const nextAfter =
    data?.length >= PAGE_SIZE ? data[data.length - 1]?.id : undefined

  const table = useReactTable({
    data: data,
    columns,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    getCoreRowModel: getCoreRowModel(),
  })

  if (isLoading || isValidating) return <Loader>Load dlc frames...</Loader>
  if (!data) return <EmptyDatas />

  return (
    <div className="flex flex-col h-[calc(100vh-150px)]">
      <div className="flex-shrink-0 mb-2">
        <DataTableToolbar mutate={mutate} nextAfter={nextAfter} />
      </div>
      <div className="flex-1 min-h-0">
        <Card className="h-full flex flex-col">
          <CardContent className="flex-1 overflow-hidden pl-4 pr-0 pb-0">
            <div className="h-full overflow-auto">
              <Table table={table} />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default DlcPanel
